// extracted by mini-css-extract-plugin
export var actions = "bx_dX";
export var content = "bx_L";
export var headline = "bx_dW";
export var imageContainer = "bx_bs";
export var singleCtaContainer = "bx_dT";
export var variant = "bx_dV";
export var wrapper = "bx_bz";